import React from 'react';

// Animation-free image (effects disabled per user request).
const SmoothImage = ({
  src,
  alt = '',
  className = '',
  imgClassName = '',
  loading = 'lazy',
  fetchPriority,
  ...rest
}) => (
  <div className={`relative bg-neutral-100 overflow-hidden ${className}`}>
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding="async"
      fetchpriority={fetchPriority}
      className={`w-full h-full object-cover ${imgClassName}`}
      {...rest}
    />
  </div>
);

export default SmoothImage;
